import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useTheme, darken, lighten } from "@mui/material/styles";
import { PangeaModal } from "@pangeacyber/react-mui-shared";
import CopyPasswordButton from "../../PasswordCopyButton";
var CopyPasswordModal = function (_a) {
    var password = _a.password, open = _a.open, onClose = _a.onClose;
    var theme = useTheme();
    var modify = theme.palette.mode === "dark" ? darken : lighten;
    return (_jsx(PangeaModal, { open: open, onClose: onClose, displayCloseIcon: true, header: _jsx(Typography, { variant: "h5", children: "Share Link Password" }), children: _jsxs(Stack, { gap: 2, children: [_jsx(Typography, { variant: "body2", color: "textSecondary", children: "Be sure to copy this password to your clipboard, you won't be able to access it again." }), _jsx(CopyPasswordButton, { label: password, value: password, variant: "contained", disableElevation: true, sx: {
                        bgcolor: modify(theme.palette.info.main, 0.9),
                        color: theme.palette.info.main,
                        ":hover": {
                            bgcolor: modify(theme.palette.info.main, 0.8),
                        },
                        paddingLeft: "0",
                        paddingRight: "0",
                    }, children: password })] }) }));
};
export default CopyPasswordModal;
